import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {
  redirectUnauthorizedTo,
  redirectLoggedInTo,
  canActivate,
} from '@angular/fire/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['tabs']);

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthPageModule),
    ...canActivate(redirectLoggedInToHome),
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'add-data',
    loadChildren: () => import('./pages/add-data/add-data.module').then( m => m.AddDataPageModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'import-data',
    loadChildren: () => import('./pages/import-data/import-data.module').then( m => m.ImportDataPageModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'message',
    loadChildren: () => import('./pages/message/message.module').then( m => m.MessagePageModule)
  },
  {
    path: 'message-detail/:id',
    loadChildren: () => import('./pages/message-detail/message-detail.module').then( m => m.MessageDetailPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'download-data',
    loadChildren: () => import('./pages/download-data/download-data.module').then( m => m.DownloadDataPageModule)
  },
  {
    path: 'security-info',
    loadChildren: () => import('./pages/security-info/security-info.module').then( m => m.SecurityInfoPageModule)
  },
  {
    path: 'delete-data',
    loadChildren: () => import('./pages/delete-data/delete-data.module').then( m => m.DeleteDataPageModule)
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  },



];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
